import { defineApi } from '@/utils/fetch';

import type { IAuthLoginResponseData, IAuthLogoutResponseData, IPostAuthLoginData } from './typings';

export const AuthApi = {
    postLogin: defineApi<IPostAuthLoginData, IAuthLoginResponseData>({
        url: '/auth/login/v1',
        method: 'POST',
        requiresAuth: false,
        axiosConfig: { timeout: 30_000 },
    }),
    postLogout: (device_id: string) => {
        const api = defineApi<undefined, IAuthLogoutResponseData>({
            url: '/user/out/v1',
            method: 'POST',
            // 登出自身已占账号等待，再进门闩会等待自己。
            requiresAuth: false,
            axiosConfig: { timeout: 30_000 },
            query: {
                device_id,
            },
        });
        return api();
    },
};

export * from './typings';
